<script>
	import { Button, Col, Row } from "@sveltestrap/sveltestrap";
	import PageHeader from "../../../../components/PageHeader/PageHeader.svelte";
	import { form, field, combined } from "svelte-forms";
	import { navigate } from "svelte-routing";
	import {
		errorMessage,
		loading,
		totalPages,
		loadingStatus,
		vehicleEditData,
	} from "../../../../store/store";
	import client from "../../../../services/client";
	import Loader from "../../../../components/Loader/Loader.svelte";
	import { required } from "svelte-forms/validators";
	import CustomInput from "../../../../components/CustomInput/CustomInput.svelte";

	let idFuelCompany = window.location.pathname.split(
		"master-data/vehicle-data/carpark-owner/edit/"
	)[1];
	export let recordId;
	let data = [];
	let FuelCompanyError;
	const FuelCompany = field("FuelCompany", $vehicleEditData.name, [
		required(),
	]);
	const myForm = form(FuelCompany);

	let load = false;
	const handleSubmit = async () => {
		try {
			load = true;
			loading.set(true);
			const res = await client("/v1/fuel/companies", {
				method: "PUT",
				version: "Vehicle",
				data: {
					name: $FuelCompany.value,
					id: recordId,
				},
			});

			if (res?.status === 200) {
				navigate("/master-data/vehicle-data/fuel-company");
			} else {
				loading.set(false);
				FuelCompanyError = res.data.message;
			}

			load = false;
			loading.set(false);
		} catch (error) {
			console.log(error);
			load = false;
			FuelCompanyError = error.response.data.message;
			loading.set(false);
		}
	};
</script>

<Row>
	<Col xs={6}>
		<Col xs={12}>
			<div>
				<Col className="row d-flex align-items-start mx-0">
					<PageHeader title="Fuel Company Data" />
				</Col>
			</div>
		</Col>
		<Col xs={12} class="my-3">
			<div>
				<h5><b>Edit Fuel Company Name</b></h5>
			</div>
			<div>
				<p>*Mandatory fields</p>
			</div>
		</Col>
		<Col>
			<Row>
				<Col>
					<label for="mobile" class="d-block">
						<span>Fuel Company Name* </span>
					</label>
				</Col>
			</Row>
			<Row>
				<Col xs={6}>
					<CustomInput
						type="text"
						bind:value={$FuelCompany.value}
						error={$myForm.hasError("FuelCompany.required") ||
							FuelCompanyError}
						errorText={$myForm.hasError("FuelCompany.required")
							? "Fuel Company name is required"
							: FuelCompanyError
								? FuelCompanyError
								: ""}
					/>
				</Col>
				<Col class="d-flex justify-content-start" xs={6}>
					<div class="mx-4 my-1">
						<Button
							class="themeButton primary px-2"
							block
							disabled={!$myForm.valid || !$FuelCompany.value}
							on:click={myForm.validate}
							on:click={() => handleSubmit()}
						>
							{#if load}
								<Loader />
							{:else}
								UPDATE
							{/if}
						</Button>
					</div>
				</Col>
			</Row>
		</Col>
	</Col>
</Row>
